import { useMemo } from "react";
import { useFetchProducts } from "~/api/salesForce/useFetchProducts";
import Radio from "~/components/atoms/Radio/Radio";
import { Product } from "~/stores/checkout/product";

type FreeProductsChevronNewProps = {
  selectedFreeProducts: Product[];
  setSelectedFreeProducts: (products: Product[]) => void;
};

const FreeProductsChevronNew = ({
  selectedFreeProducts,
  setSelectedFreeProducts,
}: FreeProductsChevronNewProps) => {
  const { data: allProducts } = useFetchProducts();
  const freeProducts = useMemo(() => {
    return [
      ...allProducts.hair.head.freePrp,
      ...allProducts.hair.head.freeMesotherapy,
      ...allProducts.skin.botox.wrinkles.freeBotox,
    ];
  }, [allProducts]);

  const onProductRadioChange = (option?: Product) => {
    if (selectedFreeProducts.some((product) => product.id === option?.id)) {
      setSelectedFreeProducts(
        selectedFreeProducts.filter((product) => product.id !== option?.id)
      );
    } else {
      setSelectedFreeProducts([...selectedFreeProducts, option as Product]);
    }
  };

  return (
    <div>
      {freeProducts.map((option, index) => (
        <Radio
          key={index}
          option={option}
          checked={selectedFreeProducts.some(
            (product) => product.id === option?.id
          )}
          onChange={onProductRadioChange}
          withCheck
          className="py-2"
        />
      ))}
    </div>
  );
};

export default FreeProductsChevronNew;
